module.exports = __webpack_public_path__ + "static/media/pilotly_svg_logo.15dcb5cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/pilotly_svg_logo.svg
// module id = 519
// module chunks = 0